import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
const ItemsCountContext = createContext(null);
export function ItemsCountProvider(t0) {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const value = rest;
  let t1;
  if ($[3] !== children || $[4] !== value) {
    t1 = <ItemsCountContext.Provider value={value}>{children}</ItemsCountContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export function useItemsCount() {
  return useContext(ItemsCountContext);
}